var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colors-range-container"},_vm._l((_vm.colors),function(color,index){return _c('button',{key:color,staticClass:"button",style:({ backgroundColor: color }),attrs:{"title":color}},[_vm._v(" "+_vm._s(index + 1)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }